import Avatar from './Avatar.vue'

type Themes = 'big' | 'huge'

export interface Props {
  picture?: string | undefined
  theme?: Themes | Array<Themes>
}

export default Avatar;